import {
  seoImages,
  urlAboutUs,
  urlHelp,
  urlImpact,
  urlRecap2017,
  urlShopProduct,
  urlVineyard,
} from '../../server/utils/urlConstants';

/*
SEO ROUTE TEMPLATE

  'name of route': { // full route path, exclude hostname
    title: 'ONEHOPE Wine | Buy Inspired & Award-Winning Wine, Gift Boxes & More', // meta title
    image: `${urlHomepageBackground}homepage-hero-serve-celebrate.jpg`, // meta image url
    imageAlt: '3 bottles of OneHope Wine Glitter Wine', // meta image alt tag
    imageHeight: 400, // height dimension of image
    imageWidth: 400,  // width dimsenion of image
    description: 'Do Good. Wine Not?', // meta description tag
  },
 */
export const seoConfig = {
  defaultRoute: {
    title:
      'ONEHOPE Wine | Buy Inspired & Award-Winning Wine, Gift Boxes & More',
    image: `${seoImages}ONEHOPE-Banner.jpg`,
    imageHeight: 593,
    imageWidth: 1898,
    imageAlt: 'ONEHOPE serve + celebrate',
    description:
      'ONEHOPE Wine is a world-class vineyard in Napa Valley that makes a positive impact on the world with every bottle sold. See whatʼs in store! Indulge. Do Good. Wine Not?',
  },
  /*
  STATIC PAGES
  */
  '': {
    title:
      'ONEHOPE Wine | Buy Inspired & Award-Winning Wine, Gift Boxes & More',
    image: `${seoImages}ONEHOPE-Banner.jpg`,
    imageAlt: 'ONEHOPE serve + celebrate',
    imageHeight: 593,
    imageWidth: 1898,
    description:
      'ONEHOPE Wine is a world-class vineyard in Napa Valley that makes a positive impact on the world with every bottle sold. See whatʼs in store! Indulge. Do Good. Wine Not?',
  },
  '2017-year-in-review': {
    title: 'Our Social Impact in 2017: Year in Review | ONEHOPE Wine',
    image: `${urlRecap2017}2017_recap_1.jpg`,
    imageAlt: 'ONEHOPE Recap',
    imageHeight: 1440,
    imageWidth: 3360,
    description:
      '2017 was our most impactful year to date, and itʼs all thanks to our customers! Come see the impact we all made in 2017, right here.',
  },
  join: {
    title: 'Become a Cause Entrepreneur | ONEHOPE Wine',
    // image: `${urlAboutUs}AboutUs.jpg`,
    // imageAlt: 'ONEHOPE Team in Vineyard',
    // imageHeight: 860,
    // imageWidth: 878,
    description: `Make friends, set your own hours, and raise money for your favorite causes while earning an income as a Cause Entrepreneur!`,
  },
  'about-us': {
    title: 'About Us | ONEHOPE Wine',
    image: `${urlAboutUs}AboutUs.jpg`,
    imageAlt: 'ONEHOPE Team in Vineyard',
    imageHeight: 860,
    imageWidth: 878,
    description:
      'ONEHOPE is a lifestyle brand with a world-class vineyard in the heart of Napa. We give back & create an impact through every product. Learn more about us here.',
  },
  impact: {
    title: 'Our Social Impact | ONEHOPE Wine',
    image: `${urlImpact}OurImpact-Hero.jpg`,
    imageAlt: 'ONEHOPE Two Children with Clean Water',
    imageHeight: 1040,
    imageWidth: 2880,
    description:
      'We believe in making a positive impact in the world every day. Browse & shop our charity wines. Plus, see the non-profit foundations we work with, here!',
  },
  'this-is-a-tree': {
    title: 'This is a Tree | ONEHOPE Wine',
    image: `${seoImages}ONEHOPE-Sauvignon-Blanc-Tree.jpg`,
    imageAlt: 'ONEHOPE Sauvignon Blanc Tree',
    imageHeight: 851,
    imageWidth: 2000,
    description:
      'We founded ONEHOPE 10 years ago on the idea that a bottle of wine can be more than just that. Watch our video & learn more today.',
  },
  vineyard: {
    title: 'Our Vineyard | ONEHOPE Wine',
    image: `${urlVineyard}Winemaking-Hero.jpg`,
    imageAlt: 'ONEHOPE Vineyard',
    imageHeight: 1040,
    imageWidth: 2880,
    description:
      'Our vision for ONEHOPE Wine is to build a community around a vineyard, estate & winery that makes the world a better place. Learn more about us, here.',
  },
  faq: {
    title: 'Frequently Asked Questions | ONEHOPE Wine',
    image: `${urlHelp}ShippingMap10022019.png`,
    imageHeight: 1257,
    imageWidth: 1884,
    imageAlt: 'ONEHOPE Shipping Map',
    description:
      'Have a question about ONEHOPE Wine Club, our wines, or a recent order? Browse through our FAQ page for answers to our frequently asked questions!',
  },
  'privacy-policy': {
    title: 'Privacy Policy | ONEHOPE Wine',
    image: `${seoImages}ONEHOPE-Banner.jpg`,
    imageHeight: 593,
    imageWidth: 1898,
    imageAlt: 'ONEHOPE serve + celebrate',
    description:
      'ONEHOPE Wine is committed to respecting and protecting your privacy as a visitor to our website. This Privacy Statement describes the practices and policies we have put into place; click to read more.',
  },
  /* ********************************************************************************************************/
  /* PCP CATALOG PAGES */
  /* ********************************************************************************************************/
  coffee: {
    title: 'Buy Coffee Online & Give Back | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Mini-Gift-Crate-Hustle-2017_detail.jpg`,
    imageAlt: 'ONEHOPE Hustle Mini Gift Crate',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'At ONEHOPE Wine, we offer more than just delicious wines. We sell gourmet coffee & coffee gifts, too! Shop our coffee blends & gift boxes & give back with every purchase.',
  },
  gift: {
    title:
      'All Gifts | Wine Gift Boxes & Crates, Coffee & More! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Box-The-Foodie-2019_detail.jpg`,
    imageAlt: 'ONEHOPE The Foodie Gift Box',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'ONEHOPE helps you deliver the perfect wine gift. With gift boxes and handcrafted birch gift crates, there are dozens of options for everyone on your list. Browse & shop today, & find the perfect gift!',
  },
  gifts: {
    title: 'Wine Gift Boxes & Crates | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Crate-Wine-Cheese-Party-2019_detail.jpg`,
    imageAlt: 'ONEHOPE Wine & Cheese Party Crate',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Looking for the perfect wine gift boxes for friends, family, or colleagues? ONEHOPE Wine is a one-stop shop for gift boxes for any occasion. Browse today & give back with every purchase!',
  },
  'gift-marketplace': {
    title: 'Marketplace | ONEHOPE Wine',
    // image: `${urlShopProduct}OHW_Swag-Hoodie-Womens-Charcoal_detail.jpg`,
    // imageAlt: 'ONEHOPE Womens Hoodie',
    // imageHeight: 900,
    // imageWidth: 1200,
    description:
      'Every ONEHOPE purchase provides a donation to a worthy non-profit. Plus, you get great marketplace items!',
  },
  'gift-wine-accessories': {
    title: 'Wine Accessories | ONEHOPE Wine',
    // image: `${urlShopProduct}OHW_Swag-Hoodie-Womens-Charcoal_detail.jpg`,
    // imageAlt: 'ONEHOPE Womens Hoodie',
    // imageHeight: 900,
    // imageWidth: 1200,
    description:
      'Every ONEHOPE purchase provides a donation to a worthy non-profit. Plus, you get great tasting wine accessories!',
  },
  'gift-non-alcoholic': {
    title:
      'No Alcohol Gift Boxes | Coffee, Cheeses, Spices & More | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Swag-WaterBottle-Grey_detail.jpg`,
    imageAlt: 'ONEHOPE Water Bottle',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'ONEHOPE Wine has you covered with a wide selection of attractive gift boxes and crates featuring a wealth of non-alcoholic goodies. Browse & shop today!',
  },
  'gift-swag': {
    title: 'ONEHOPE Wine Clothing | Hats, Shirts & Swag',
    image: `${urlShopProduct}OHW_Swag-Hoodie-Womens-Charcoal_detail.jpg`,
    imageAlt: 'ONEHOPE Womens Hoodie',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Every ONEHOPE purchase provides a donation to a worthy non-profit. Plus, you get great tasting wine & coffee! Shop our hats, shirts & other swag here!',
  },
  'gift-wine': {
    title: 'Gifts With Only Wine Bottles | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-4-Bottle-Wood-Box-2018_detail.jpg`,
    imageAlt: 'ONEHOPE 4 Bottle Wood Gift Box',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Browse all of our gifts that feature only what you love best; wine. Buy today & give back with every purchase. Indulge and do good.',
  },
  kitchen: {
    title: 'Kitchen Gift Sets | Sauces, Spreads, & More | ONEHOPE Wine',
    image: `${urlShopProduct}OHK_Set-Pasta-And-Bruschetta_detail.jpg`,
    imageAlt: 'ONEHOPE Pasta and Bruschetta Set',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'At ONEHOPE Wine, we offer more than just delicious wines. We sell kitchen gift sets too, including delicious sauces, spreads, bruschetta & more, so shop today!',
  },
  wine: {
    title:
      'Buy Award-Winning Wine Online & Give Back with Every Bottle | ONEHOPE Wine',
    image: `${urlShopProduct}/OHW_Wine-Reserve-Napa-Valley-Cabernet-Sauvignon-2015_detail_front.jpg`,
    imageAlt: 'ONEHOPE Napa Valley Cabernet Sauvignon',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy inspired, award-winning, wines online & give back to a great cause with every bottle purchased. Enjoy our red, white, sparkling & rosé wines & do good today!',
  },
  'wine-cabernet': {
    title:
      'Buy Cabernet Sauvignon Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-Napa-Valley-Cabernet-Sauvignon-2015_detail_front.jpg`,
    imageAlt: 'ONEHOPE Napa Valley Cabernet Sauvignon',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy cabernet sauvignon at great prices & support great causes like ABA therapy & improving education in the developing world with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-chardonnay': {
    title:
      'Buy Chardonnay Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Vintner-Collection-Chardonnay-Award-Winning_detail.jpg`,
    imageAlt: 'ONEHOPE Vintner Chardonnay',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy chardonnay at great prices & support causes like ending bullying and funding Alzheimerʼs research with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-dessert': {
    title:
      'Buy Dessert Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-29-Twelve-California-Dessert-Wine-VII_detail_front.jpg`,
    imageAlt: 'ONEHOPE 29 Twelve California Dessert Wine V.II',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy dessert wine at great prices & support great causes like cancer screenings with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-fume-blanc': {
    title: 'Buy Fumé Blanc Wine & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Estate-Fume-Blanc_detail_front.jpg`,
    imageAlt: 'ONEHOPE Estate Fumé Blanc',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy fumé blanc at great prices & support causes like medical care for farm workers with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-glitter': {
    title:
      'Buy Glitter Bottle Wine and Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Glitter-Gold-Celebration-Brut-2017_detail_front.jpg`,
    imageAlt: 'ONEHOPE Celebration Brut Gold Glitter',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy our famous glitter bottles at great prices & support important causes with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-malbec': {
    title:
      'Buy Malbec Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-Argentina-Malbec-2016_detail_front.jpg`,
    imageAlt: 'ONEHOPE Argentinan Malbec',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy malbec wine at great prices & support causes like helping to fund Alzheimerʼs studies with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-merlot': {
    title:
      'Buy Merlot Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Vintner-Collection-Merlot_detail_front.jpg`,
    imageAlt: 'ONEHOPE Vintner Merlot',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy merlot wine at great prices & support causes like healthcare for children with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-prosecco': {
    title:
      'Buy Prosecco Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-Italian-Prosecco-2016_detail_front.jpg`,
    imageAlt: 'ONEHOPE Italian-Prosecco',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy Prosecco wine at great prices & support causes like meals for children with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-muscat-canelli': {
    title: 'Buy Muscat Canelli & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Core-Collection-California-Muscat-Canelli-2016_detail_front.jpg`,
    imageAlt: 'ONEHOPE California Muscat Canelli',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy muscat canelli at great prices & support important causes with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-pinot-grigio': {
    title:
      'Buy Pinot Grigio Wine & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Italian-Delle-Venezie-Pinot-Grigio-2017_detail_front.jpg`,
    imageAlt: 'ONEHOPE Italian Pinot Grigio',
    description:
      'Buy pinot grigio at great prices & support causes like funding pet adoptions with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-pinot-noir': {
    title:
      'Buy Pinot Noir Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-Edna-Valley-Pinot-Noir-2014_detail_front.jpg`,
    imageAlt: 'ONEHOPE Edna Valley Pinot Noir',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy pinot noir at great prices & support causes like heart disease education and pet adoption with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-red': {
    title: 'Buy Red Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-Napa-Valley-Red-Blend-2015_detail_front.jpg`,
    imageAlt: 'ONEHOPE Napa Valley Red Blend',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy award-winning red wines at great prices & give back to a great cause with each bottle purchased. We carry cab savs, merlots, pinot noirs & much more. Find your wine today!',
  },
  'wine-red-blend': {
    title:
      'Buy Red Blend Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Vintner-Collection-Red-Blend-Award-Winning_detail.jpg`,
    imageAlt: 'ONEHOPE Vintner Red Blend',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy red blend at great prices & support causes like helping the homeless and supporting veterans with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-riesling': {
    title: 'Buy Riesling Wine & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Core-Collection-California-Riesling-2017_detail_front.jpg`,
    imageAlt: 'ONEHOPE California Riesling',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy riesling at great prices & support important causes like funding literacy education for children with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-rose': {
    title: 'Buy Rosé Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-Provence-Rose-2016_detail_front.jpg`,
    imageAlt: 'ONEHOPE Provence Rosé',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy award-winning rosés at great prices & support cancer education for 200 women with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-sauvignon-blanc': {
    title:
      'Buy Sauvignon Blanc Wine & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Vintner-Collection-Sauvignon-Blanc-detail-front.jpg`,
    imageAlt: 'ONEHOPE Vintner Sauvignon Blanc',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy sauvignon blanc at great prices & support important causes like reforestation with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-sparkling': {
    title:
      'Buy Sparkling Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Glitter-Gold-Celebration-Brut-2017_detail_front.jpg`,
    imageAlt: 'ONEHOPE Celebration Brut Gold Glitter',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy award-winning sparkling wines at great prices & give back to a great cause with each bottle purchased. From bruts to sparkling rosés to glitter bottles, thereʼs something for everyone. Find your wine today!',
  },
  'wine-symphony': {
    title:
      'Buy Symphony Blanc Wine & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Core-Collection-California-Symphony_detail_front.jpg`,
    imageAlt: 'ONEHOPE California Symphony Wine',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy symphony wine at great prices & support great causes with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-viognier': {
    title:
      'Buy Viognier Blanc Wine & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Core-Collection-California-Viognier-2016_detail_front.jpg`,
    imageAlt: 'ONEHOPE California Viognier',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy viognier wine at great prices & support great causes with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-white': {
    title:
      'Buy White Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Italian-Delle-Venezie-Pinot-Grigio-2017_detail_front.jpg`,
    imageAlt: 'ONEHOPE Italian Pinot Grigio',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy award-winning white wines at great prices & give back to a great cause with each bottle purchased. We carry chardonnays, sauv blancs, rieslings & much more. Find your wine today!',
  },
  'wine-zinfandel': {
    title:
      'Buy Zinfandel Wine Online & Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-North-Coast-Zinfandel-2015_detail_front.jpg`,
    imageAlt: 'ONEHOPE North Coast Zinfandel',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy zinfandel at great prices & support causes like supporting veterans with each bottle purchased. Enjoy wine & give back today!',
  },
  'wine-collection-limited': {
    title: 'Limited Edition Wine | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Iconic-Chardonnay-2018_detail.jpg`,
    imageAlt: 'ONEHOPE Iconic Chardonnay',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Celebrate our 10 year anniversary with our limited edition wine collection. Shop while doing good!',
  },
  'wine-collection-vintner': {
    title: 'Vintner Wine Collection | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Vintner-Collection-Chardonnay-Award-Winning_detail.jpg`,
    imageAlt: 'ONEHOPE California Vintner Chardonnay',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Shop ONEHOPE Wineʼs Vintner Collection! Featuring delicious California wines such as chardonnay, brut & merlot - see the complete collection here and support great causes with every purchase.',
  },
  'wine-collection-core': {
    title: 'Core Wine Collection | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Core-Collection-California-Riesling-2017_detail_front.jpg`,
    imageAlt: 'ONEHOPE California Riesling',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Shop ONEHOPE Wineʼs Core Collection! Featuring delicious California wines such as chardonnay, brut & merlot - see the complete collection here and support great causes with every purchase.',
  },
  'wine-collection-reserve': {
    title: 'Reserve Wine Collection | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Reserve-Napa-Valley-Cabernet-Sauvignon-2016_detail.jpg`,
    imageAlt: 'ONEHOPE Napa Valley Cabernet Sauvignon',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Browse & shop ONEHOPE Wineʼs reserve wine collection! Featuring delicious California wines such as chardonnay, brut & merlot - see the complete collection here and support great causes with every purchase.',
  },
  'wine-collection-iconic': {
    title: 'Iconic Wine Collection | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Estate-Fume-Blanc_detail_front.jpg`,
    imageAlt: 'ONEHOPE Estate Fumé Blanc',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'ONEHOPE’s Iconic Collection features exceptional wines from some of Napa Valley’s most prestigious AVAs. Browse today & experience the best Napa has to offer!',
  },
  'wine-collection-signature': {
    title: 'Signature Wine Collection | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Signature-Sara-Evans-Cabernet-Sauvignon_detail_front.jpg`,
    imageAlt:
      'ONEHOPE Sara Evans Signature Series Napa Valley Cabernet Sauvignon',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Browse our Signature Series wine collection! From our Pinot Noir to our Cabernet Sauvignon, each purchase gives a donation to a non-profit. Shop now!',
  },
  'wine-collection-mixed': {
    title: 'Mixed Wine Packs | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Mixed-Packs-Award-Wining-2_detail.jpg`,
    imageAlt: 'ONEHOPE Award Winning Mixed Pack',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Our wine packs are an ideal choice for wine lovers who canʼt decide! From our Best Of California to our Glitter Bottle mixed packs - browse them all here and give back with every purchase.',
  },
  /* ********************************************************************************************************/
  /* CUSTOM PCP CATALOG ROUTES */
  /* ********************************************************************************************************/
  'gifts-best-selling': {
    title: 'Our Best Selling Gifts | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Box-Pinot-For-Paws-Woof-2019_detail.jpg`,
    imageAlt: 'ONEHOPE Woof Gift Box',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Browse all of our most popular gifts in one convenient location. Give to others & support great, important causes with each purchase!',
  },
  'valentines-day': {
    title: 'Valentines Day Gift Guide | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-2-Bottle-Wood-Box-Valentines-ValentinesDay-2019_detail.jpg`,
    imageAlt: "ONEHOPE Valentine's Day Etched Two-Bottle Wood Gift Box Set",
    imageHeight: 900,
    imageWidth: 1200,
    description:
      "Looking for the perfect gift for the love in your life? Check out our gift guide to see our favorite Valentine's gifts, and make a social impact with your purchase.",
  },
  'guide-for-cabernet': {
    title: 'Cabernet Lovers Gift Guide | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Box-Cookies-Cab-2019_detail.jpg`,
    imageAlt: 'ONEHOPE Cookies and Cabernet Gift Box',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Looking for the perfect gift for the cabernet lover in your life? Check out our gift guide to see our favorite cabernet gifts, and make a social impact with your purchase.',
  },
  'guide-for-gals': {
    title: 'Wine Gift Guide for Women | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Box-Frose-2019_detail.jpg`,
    imageAlt: 'ONEHOPE Frosé Gift Box',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'When buying gifts for the women in your life, why not get them wine? Check out gift guide guide & get something great for the lady in your life, while giving back at the same time.',
  },
  'guide-for-guys': {
    title: 'Wine Gift Guide for Men | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Iconic-Oakville-Cabernet-Sauvignon_detail_front.jpg`,
    imageAlt: 'ONEHOPE Oakville Cabernet Sauvignon',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'When buying gifts for the men in your life, why not get them wine? Check out gift guide guide & get something great for the man in your life, while giving back at the same time.',
  },
  'guide-for-moms': {
    title: 'Wine Gift Guide for Moms | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Box-The-Green-Thumb-2019_detail.jpg`,
    imageAlt: 'ONEHOPE The Green Thumb Box',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'When buying gifts for the mom in your life, why not get them wine? Check out gift guide guide & get something great for the mom in your life, while giving back at the same time.',
  },
  'guide-for-pet-lovers': {
    title: 'Wine Gift Guide for Pet Lovers | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Box-Pinot-For-Paws-Woof-2019_detail.jpg`,
    imageAlt: 'ONEHOPE Woof Box Gift Box',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Looking for the perfect gift for the pet lover in your life? Check out our gift guide to see our favorite gifts that support animals with every purchase.',
  },
  'guide-for-teachers': {
    title: 'Wine Gift Guide for Teachers | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Crate-Picnic-Perfect-2019-2_detail.jpg`,
    imageAlt: 'ONEHOPE Picnic Perfect Gift Crate',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Finding the perfect gift for your child’s teacher can be a struggle, which is why we put together this awesome guide; check it out today and give back with every purchase!',
  },
  'guide-for-the-host': {
    title: 'Wine Gift Guide for the Host | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Gift-Crate-Wine-Cheese-Party-2019_detail.jpg`,
    imageAlt: 'ONEHOPE Wine & Cheese Party Crate',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'We all have that friend who loves to be the host. Get them the perfect gift from our curated host gift guide, & know youʼre making a positive social impact with any purchase!',
  },
  'wine-best-selling': {
    title:
      'Our Best Selling Wine | Give Back with Every Bottle! | ONEHOPE Wine',
    image: `${urlShopProduct}OHW_Wine-Glitter-Gold-Sparkling-Brut_detail_front.jpg`,
    imageAlt: 'ONEHOPE Sparkling Brut Gold Glitter',
    imageHeight: 900,
    imageWidth: 1200,
    description:
      'Buy our best-selling wines online & give back to a great cause with every bottle purchased. Enjoy our most popular red, white, sparkling & rosé wines & do good today!',
  },
};
